// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".level-div {\n  display: flex;\n  position: absolute;\n  text-align: center;\n  bottom: 5%;\n  height: 30px;\n  width: 100%;\n  font-family: \"Sigmar One\";\n  color: white;\n  justify-content: flex-start;\n  padding-left: 5%;\n}\n\n.level-text {\n  font-size: 2.5rem;\n  -webkit-text-stroke: 1px black;\n}\n", ""]);
// Exports
module.exports = exports;
